import React, { useState } from "react";
import PropTypes from "prop-types";

import { useWindowSize } from "hooks";
import { K_MOBILE_SIZE } from "constants.js";

const Pill = (props) => {
  const { primaryColor, secondaryColor, text } = props;
  const { width } = useWindowSize();

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };

  const [isHovered, setIsHovered] = useState(false);

  const colorStyle = {
    pillColor: {
      backgroundColor: isHovered ? primaryColor : secondaryColor,
    },
    textColor: {
      color: isHovered ? secondaryColor : primaryColor,
    },
  };

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ ...styles.pill, ...colorStyle.pillColor }}
    >
      <span style={{ ...styles.text, ...colorStyle.textColor }}>{text}</span>
    </button>
  );
};

const pcStyles = {
  pill: {
    paddingTop: "0.25rem",
    paddingBottom: "0.25rem",
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    minWidth: "100px",
    borderRadius: "0.5rem",
    textAlign: "center",
    transition: "0.35s",
    margin: "0.25rem",
  },
  text: {
    fontSize: "0.75rem",
    fontWeight: "bold",
  },
};

const mobileStyles = {
  pill: {
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem",
    paddingLeft: "0.25rem",
    paddingRight: "0.25rem",
    minWidth: "75px",
    borderRadius: "0.5rem",
    textAlign: "center",
    transition: "0.35s",
    margin: "0.2rem",
  },
  text: {
    fontSize: "0.6rem",
    fontWeight: "bold",
  },
};

Pill.propTypes = {
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Pill;
